module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/942a669c040a4579e548cea4caaf933c.png";